module.exports = __webpack_public_path__ + "static/media/PM23.f4a68310.png";